import { render, staticRenderFns } from "./ResetModal.vue?vue&type=template&id=3f1f8357&lang=pug&"
import script from "./ResetModal.vue?vue&type=script&lang=ts&"
export * from "./ResetModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports